import {
  useRouter,
  isNavigationFailure,
  NavigationFailureType,
} from "vue-router";

export function useCommon() {
  const router = useRouter();

  const goPage = (link) => {
    router.push(link).catch((err) => {
      if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
        throw err;
      }
    });
  };

  return {
    goPage,
  };
}
